import { AppRoute as R } from 'common/routing/app-route';
import { ParametrizedAppRoute as PR } from 'common/routing/parametrized-app-route';
import { CompanySubscriptionParams } from './route-params';

/* eslint-disable max-len, space-in-parens */
const index =         new PR<CompanySubscriptionParams>(`/company/:companyId/:type`);
const billingNotice = new R(                            `${index.path}/billing-notice`);
const manageCompany = new R(                            `${index.path}/manage`);
/* eslint-enable */

export const Urls = {
  index,
  billingNotice,
  manageCompany,
};

